var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.5A4.5 4.5 0 003.5 6v5H2v1h12v-1h-1.5V6A4.5 4.5 0 008 1.5zm3.5 9.5V6a3.5 3.5 0 10-7 0v5h7z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    d: "M5.334 13.5h5.333"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04IDEuNUM1LjUxNDcyIDEuNSAzLjUgMy41MTQ3MiAzLjUgNlYxMUgyVjEySDMuNUg0LjVIMTEuNUgxMi41SDE0VjExSDEyLjVWNkMxMi41IDMuNTE0NzIgMTAuNDg1MyAxLjUgOCAxLjVaTTExLjUgMTFWNkMxMS41IDQuMDY3IDkuOTMzIDIuNSA4IDIuNUM2LjA2NyAyLjUgNC41IDQuMDY3IDQuNSA2VjExSDExLjVaIiBmaWxsPSJ3aGl0ZSIvPgo8bGluZSB4MT0iNS4zMzM5OCIgeTE9IjEzLjUiIHgyPSIxMC42NjczIiB5Mj0iMTMuNSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";
export { SvgListAlert as ReactComponent };